export default {
  DISPLAY_TIME_SUCCESS: 6000,
  DISPLAY_TIME_ERROR: 15000,
  DISPLAY_TIME_LONG: 18000,
};
